import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { supabase } from "../lib/supabase";
import type { Session } from "@supabase/supabase-js";

const AuthHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getSafeRedirectPath = (value: unknown) => {
    if (!value || typeof value !== "object") return "/dashboard";
    const candidate = value as { pathname?: string; search?: string; hash?: string };
    const pathname = typeof candidate.pathname === "string" ? candidate.pathname : "";
    const search = typeof candidate.search === "string" ? candidate.search : "";
    const hash = typeof candidate.hash === "string" ? candidate.hash : "";

    if (!pathname.startsWith("/") || pathname.startsWith("//") || pathname.startsWith("/login") || pathname.startsWith("/register")) {
      return "/dashboard";
    }

    return `${pathname}${search}${hash}`;
  };

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event: string, session: Session | null) => {
      if (session && location.pathname === "/login" && window.location.hash.includes("access_token")) {
        navigate(getSafeRedirectPath((location.state as { from?: unknown } | null)?.from), { replace: true });
      }
    });
    return () => {
      subscription.unsubscribe();
    };
  }, [navigate, location.pathname, location.state]);

  return null;
};

export default AuthHandler; 
